import { useAsset } from "../../AssetHelper";

import './CmpBar.scss'
import ScrollingText from "../components/ScrollingText";
import { ReactNode, useContext } from "react";
import {t} from "../../i18n";
import DisplayParams from "../DisplayParams";
import {ReactSVG} from "react-svg";
import EventLogo from "../components/EventLogo";
import {escape} from "lodash";

// This is also gross and ideally would be handled somewhere else
export function truncateMatchNameForCmpBar(matchName: string) {
    let ret = matchName;
    // Strip the playoff prefix to make space for long tiebreaker names
    if(ret.includes(" Tiebreaker")) {
        ret = ret.replace(/.* Match/, " Match")
    } else if(ret.includes(" of ")) {
        ret = ret.split(" of ")[0];
    }
    return ret
}

export default function CmpBar({pageTitle, timer, hideMiddleBar, children, className, eventNameOverride, shortEventName} : {
    pageTitle?: ReactNode,
    timer?: string,
    hideMiddleBar?: boolean,
    children: ReactNode,
    className?: string,
    eventNameOverride?: ReactNode,
    shortEventName?: boolean
}) {
    const displayParams = useContext(DisplayParams);
    const sponsorSuffix = displayParams.alternatePresentingSponsor ? '_' + displayParams.alternatePresentingSponsor : '';
    // This is gross and ideally would be handled somewhere else
    const formattedEventName = escape(displayParams.eventName.replace(" Division", "")).replaceAll(/\bFIRST\b/g, "<i>FIRST</i>")
    const nameWrapper = eventNameOverride || <div className={"nameWrapper"}><EventLogo logo={displayParams.eventLogo}/> <span dangerouslySetInnerHTML={{__html: formattedEventName}} /></div>;
    const sponsorIntro = displayParams.eventSponsor ? <div className={"sponsorIntro"}>{t`Sponsored By`}</div> : null;

    return <div className={`h-100 w-100 ${className}`}>
        <div className={`barContainer`}>
            {hideMiddleBar ? null : <div className={`centerBar ${timer ? 'withTimer' : ''} ${displayParams.divisionNumber == 0 ? 'parent' : ''}`}>
                {timer ? <svg width="235px" height="128px" className={"barBackground"}>
                    <polygon points="0,0 235,0 235,40 0,40" fill="black" stroke="none" />
                    <polygon points="0,40 235,40 235,128 0,128" fill="white" stroke="none" />
                </svg> : <svg width="160px" height="128px" className={"barBackground"}>
                    <polygon points="0,0 160,0 160,128 0,128" fill="white" stroke="none" />
                </svg>}
                <span className={"timerText"}>{timer}</span>
                <span className={`eventName ${shortEventName ? "shortEventName" : ""}`}>
                    <div className={"eventNameInner"}>{nameWrapper} {timer ? <span>{sponsorIntro}</span> : null}</div>
                    {displayParams.eventSponsor ? <>
                        {timer ? null : <span>{sponsorIntro}</span>}
                        <img src={displayParams.eventSponsor.logo} className={"sponsorLogo"} />
                    </> : null}
                </span>
                <span className={"title"}>{pageTitle}</span>
            </div>}
            {children}
        </div>
    </div>;
}